import React from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router';
import {
  getCurrentRoute,
  nextCalculatorPage,
  previousCalculatorPage,
  goToRouteByName,
  getNextRoute,
  getPreviousRoute,
  getRouteTitle,
  getCurrentRouteIndex,
  calculatorPages,
  routes,
} from './routerHelper';
import Types from '../types';

export const withRouterAndHelpers = (Component) => {
  const wrapped = ({ history, location, match, ...props }, { i18n }) => {
    const currentRoute = getCurrentRoute(location, i18n);
    const nextRoute = getNextRoute(currentRoute);
    const previousRoute = getPreviousRoute(currentRoute);
    const currentRouteIndex = getCurrentRouteIndex(location, i18n);

    const canNavToNext = calculatorPages.indexOf(currentRoute) >= 0 &&
      calculatorPages.indexOf(currentRoute) < calculatorPages.indexOf(routes.TAKE_ACTION);
    const canNavToPrevious = calculatorPages.indexOf(currentRoute) >= 0 &&
      calculatorPages.indexOf(currentRoute) > calculatorPages.indexOf(routes.GET_STARTED);
    return (
      <Component
        history={history}
        location={location}
        match={match}
        currentRoute={currentRoute}
        currentRouteIndex={currentRouteIndex}
        nextRoute={nextRoute}
        previousRoute={previousRoute}
        getRouteTitle={route => getRouteTitle(route, i18n)}
        nextCalculatorPage={() => nextCalculatorPage(location, history, i18n)}
        previousCalculatorPage={() => previousCalculatorPage(location, history, i18n)}
        goToRouteByName={routeName => goToRouteByName(routeName, history, i18n)}
        canNavToNext={canNavToNext}
        canNavToPrevious={canNavToPrevious}
        {...props}
      />
    );
  };
  wrapped.propTypes = {
    match: Types.RouterMatch.isRequired,
    history: Types.RouterHistory.isRequired,
    location: Types.RouterLocation.isRequired,
  };
  wrapped.contextTypes = {
    i18n: Types.I18n.isRequired,
  };
  return withRouter(wrapped);
};

export const withT = (namespace = 'common') => {
  if (typeof namespace !== 'string') {
    throw new Error(`namespace must be string. received ${typeof namespace}.`);
  }
  return (Component) => {
    if (typeof Component !== 'function' && !(Component instanceof React.Component)) {
      throw new Error(`Cannot wrap component of type ${typeof Component}.`);
    }
    const wrapped = (props, { i18n }) => {
      const t = i18n.getFixedT(null, namespace);
      const _t = (...args) => _(t(...args));
      return (
        <Component
          t={t}
          _t={_t}
          i18n={i18n}
          {...props}
        />
      );
    };

    wrapped.contextTypes = {
      i18n: Types.I18n.isRequired,
    };
    return wrapped;
  };
};

export const wrap = (...args) =>
  args.reverse().reduce((Component, wrapper) => wrapper(Component));
